import React, { useEffect, useState, memo } from "react";
import axios from 'axios';
import { useRecoilState, useRecoilValue } from "recoil";

import { PopoverText } from '../../common/parts/PopoverText';
import { PrefOptionList } from '../parts/PrefOptionList';

import { confirmState } from '../../../store/confirmState';
import { orderState } from '../../../store/orderState';
import { optionState } from '../../../store/optionState';
import { userState } from '../../../store/userState';
import { courceClinicState } from '../../../store/courceClinicState';
import { selectedCourceClinicState } from '../../../store/selectedCourceClinicState';

export const FormClinic = memo((props) => {
  const { pageAction, cource_clinics } = props;
  const isConfirm = useRecoilValue(confirmState);
  const [orderData, setOrderData] = useRecoilState(orderState);
  const [optionData, setOptionData] = useRecoilState(optionState);
  const [courceClinicData, setCourceClinicData] = useRecoilState(courceClinicState);
  const [selectedCourceClinic, setSelectedCourceClinic] = useRecoilState(selectedCourceClinicState);
  const [prefCourceClinicData, setPrefCourceClinicData] = useState([]); //市区町村絞り込み前のdefault状態
  const userData = useRecoilValue(userState);
  const [inputArea, setInputArea] = useState('');
  const [timer, setTimer] = useState(null);
  const initialSelectedCourceClinic = {
    id: '',
    clinic_id: null,
    name: null,
    prefecture_code: null,
    address: null,
    tel: null,
  }

  // 編集時の初期データセット
  if (pageAction === "edit") {
    useEffect(() => {
      setPrefCourceClinicData(cource_clinics);
    }, []);
  }

    // 検査オプション未選択状態に設定(選択後にも対応する為)
  const resetSelectOptionsCheckbox = () => {
    const selectOptionsCheckbox = document.getElementsByName("selectOptions");
    selectOptionsCheckbox.forEach(e => {
      e.checked = false
    });
  }

  const getClinics = async (data) => {
    // axios csrfToken
    const csrfToken = document.querySelector('[name=csrf-token]').content
    axios.defaults.headers.common['X-CSRF-Token'] = csrfToken

    // ClinicServicesテーブルから医療機関を抽出
    const res = await axios.get(`/api/v1/clinics`, data)
                .then(resp => {
                  console.log("get clinics success");
                  console.log(resp.data);
                  setPrefCourceClinicData(resp.data.cource_clinics);
                  setCourceClinicData(resp.data.cource_clinics);
                })
                .catch(e => {
                  console.log("clinics error");
                  console.log(e.response);
                });
    return res;
  }

  const onChangePref = (e) => {
    setOrderData({
      ...orderData,
      requestpref_code: e.target.value,
      requestclinic_id: null,
      requestclinic: null,
      requestcource_clinic_id: '',
      options: [],
      requestdt1: null,
      requestdt1_ampm: '0',
      requestdt2: null,
      requestdt2_ampm: '0',
      requestdt3: null,
      requestdt3_ampm: '0',
      requestnote: '',
      examdt: null,
      examdtime: '',
      item_id: null,
    });
    setInputArea('');
    resetSelectOptionsCheckbox();
    setOptionData(null);
    setSelectedCourceClinic(initialSelectedCourceClinic);
    var data = { params: {
      prefecture_code: e.target.value,
      cource_id: orderData.cource_id
    }};
    getClinics(data);
  }

  const searchClinics = (keywords) => {
    const searchClinics = prefCourceClinicData.filter((item) => (
      item.address.toLowerCase().indexOf(keywords) >= 0 ||
      item.name.toLowerCase().indexOf(keywords) >= 0
    ));
    setCourceClinicData(searchClinics);
  }

  const onChangeInputArea = (e) => {
    setInputArea(e.target.value);
    clearTimeout(timer);
    const newTimer = setTimeout(() => {
      searchClinics(e.target.value)
    }, 800)
    setTimer(newTimer)
  }

  const getOptions = async (data) => {
    // axios csrfToken
    const csrfToken = document.querySelector('[name=csrf-token]').content
    axios.defaults.headers.common['X-CSRF-Token'] = csrfToken

    // ServiceOptionsテーブルからオプションを抽出
    const res = await axios.get(`/api/v1/options`, data)
                .then(resp => {
                  console.log("get options success");
                  console.log(resp.data);
                  setOptionData(resp.data.options);
                })
                .catch(e => {
                  console.log("option error");
                  console.log(e.response);
                });
    return res;
  }

  const onChangeClinic = (e) => {
    let cource_clinic = courceClinicData.find(cource_clinic => cource_clinic.id === Number(e.target.value));
    setSelectedCourceClinic(cource_clinic);
    setOrderData({
      ...orderData,
      requestcource_clinic_id: cource_clinic.id,
      requestpref_code: cource_clinic.prefecture_code,
      requestclinic_id: cource_clinic.clinic_id,
      requestclinic: cource_clinic.name,
      options: [],
      requestdt1: null,
      requestdt1_ampm: '0',
      requestdt2: null,
      requestdt2_ampm: '0',
      requestdt3: null,
      requestdt3_ampm: '0',
      requestnote: '',
      examdt: null,
      examdtime: '',
      item_id: null,
    });
    var data = { params: {
      // cource_clinic_id: e.target.value,
      clinic_service_id: e.target.value,
      user_id: userData.user_id,
    }};
    getOptions(data);
    resetSelectOptionsCheckbox();
  }

  return (
    <>
      <p className="h3">医療機関の選択
        <PopoverText textTitle="医療機関の選択" textBody="都道府県を選択し、医療機関を選択してください。" />
      </p>

      <div className="card mb-4">
        <div className="card-body">
          <div className="input-group mb-3">
            <label className="input-group-text" htmlFor="todofukenselect">都道府県</label>
            <select value={orderData.requestpref_code} className="form-select" aria-label="Default select edit" id="todofukenselect" onChange={onChangePref} disabled={!orderData.cource_code || isConfirm}>
              <PrefOptionList />
            </select>
          </div>
          <div className="input-group mb-3">
            <label className="input-group-text" htmlFor="shikuchoson">市区町村</label>
            <input
              type="text"
              className="form-control"
              name=""
              id="shikuchoson"
              placeholder="絞り込みに市区町村名や医療機関名を入力してください"
              value={inputArea}
              onChange={onChangeInputArea}
              disabled={prefCourceClinicData.length === 0 || isConfirm}
            />
          </div>
          <hr />
          <div className="row gy-3">
            <div className="col-sm">
              <div className="select optional form_order_order_items_requesthospital">
                <input type="text" className="form-control" name="" id="clinics" placeholder={courceClinicData?.length > 0 ? '下のリストから選択してください（必須）' : '選択できる医療機関がありません'} disabled />
                { pageAction === "edit" ?
                  <select value={selectedCourceClinic.id} className="form-select" size="7" aria-label="size 3 select example"  onChange={onChangeClinic} disabled={isConfirm}>
                    <option value="" disabled>医療機関を表示する</option>
                    {courceClinicData?.map(item =>
                      <option key={item.id} value={item.id}>{item.name}</option>
                    )}
                  </select>
                :
                  <select value={orderData.requestcource_clinic_id} className="form-select" size="7" aria-label="size 3 select example"  onChange={onChangeClinic} disabled={isConfirm}>
                    <option value="" disabled>医療機関を表示する</option>
                    {courceClinicData?.map(item =>
                      <option key={item.id} value={item.id}>{item.name}</option>
                    )}
                  </select>
                }
              </div>
            </div>
            <div className="col-sm">
              <div className="card bg-light">
                <div className="card-header">病院情報</div>
                <div className="card-body">
                  選択された病院の情報が表示されます。<br /><br />
                  医療機関名：{selectedCourceClinic.name}<br />
                  住所：{selectedCourceClinic.address}<br />
                  電話番号：{selectedCourceClinic.tel}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <p className="text-center h1"><i className="fas fa-chevron-down"></i></p>
    </>
  );
});
